<template>
  <div class="all-style-bgc">
    <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoreportInternet">清风论坛></span>
        <span @click="GoreportEvaluation">他山之石></span>
        <span @click="GoreportOutside">学习他人></span>
        <span class="red">正文</span>
      </div>
      <!--正文内容-->
      <div class="text">
        <h1>黄克立：基层监督执纪问责要突出“三看”</h1>
        <h2>
          来源：新华社
          <span class="mg-16">|</span>
          发布时间：2020-03-30&nbsp;13:30
        </h2>
        <h3>2018年5月，中共中央办公厅印发了《关于进一步激励广大干部新时代新担当新作为的意见》，强调要全面落实习近平总书记关于“三个区分开来”的重要要求，建立容错纠错机制，宽容干部在工作中特别是改革创新中的失误错误，旗帜鲜明为敢于担当的干部撑腰鼓劲。2019年3月，习近平总书记在十九届中央纪委三次全会上指出问责工作中存在问责不力、问责泛化简单化等突出问题。基层干部作为政策最终的落实者、执行者，工作千头万绪，很容易成为问责对象，可以说，问责泛化简单化成为基层干部工作的最大隐忧。为了让担当有为者放下包袱，让违法乱纪者受到惩戒。在基层监督执纪问责实践中要突出“三看”。,把信访举报作为纪律审查的线索的第一来源渠道，充分发挥其“预警器”和“晴雨表”作用，注重精准分析，提高办信质效，积极探索化解基层信访问题的新途径、新办法，不断推进信访举报工作高质量发展。</h3>
        <h3>
          <b>一看主观动机。</b>
        </h3>
        <h3>(主观动机是指违纪行为人是在怎样的心理支配下实施违纪行为，是工作失误还是主观故意，出于什么目的和动机，是为公还是为私？同样的违纪行为，动机不同，表现出的危害程度就会不同，处理也就不同。如同样是采取拆分工程的方式规避招投标，一个是为了谋取私利暗箱操作，一个是为了赶工程进度，确保如期完成易地扶贫搬迁安置工程，处分自然大不相同。前者从重处分，后者从轻处分甚至可以视情况免予处分。当然“容错”不是“纵错”，哪些错能容，哪些底线不能触碰？就需要准确分析违纪行为产生的主观动机，明辨“为公”还是“为私”，分清“无心过失”还是“故意违纪”，可容为公之失，不赦为私之恶。对谋取私利，明知故犯，甚至一错再错的，从重加重处分；对出于公心，工作出现失误，或虽然实施了违纪行为，但目的是避免更严重的后果且经集体研究决定的，就可在精准把握事实情况的前提下，给予宽容和改正错误的机会。.11%。从村（社区）干部受处理具体案例来分析，两人或两人以上“抱团”违纪现象比较普遍。主要表现为以村支部书记、主任为核心，其他村组干部参与、共同“谋划”的利益“小团体”，成为违纪违法问题的高危群体。如，该市太平镇崔垱村、大王村从村支部书记到村委会委员，集体挪用粮食直补款、坐收坐支集体资金等，涉及村“两委”干部达5人。+体会交流+廉政党课”的方式召开了“一案一教育”警示教育大会，强化警示教育的感染力和说服力。</h3>
        <h3>
          <b>二看危害结果。</b>
        </h3>
        <h3>危害结果是指行为人实施的危害行为对党、国家和人民利益造成的损害事实。认定造成危害后果，需要同时满足三个条件：危害结果必须是危害行为造成的；危害结果必须是对党、国家和人民利益造成的损害事实；危害结果必须是客观存在的事实。在工作失职渎职行为中，危害结果是否发生和轻重大小直接决定是否构成违纪行为，如果没有发生结果或者结果没有达到一定程度，就不构成违纪。在问责实践中，有的地方没有对干部的履职情况进行具体核查，也没有查明履职行为与危害后果存在的因果关系，更没有区分责任类型，仅仅根据上级部门的问题清单就处分人，甚至在责任层层甩“锅”下，谁做事就处分谁，这是对党的事业和基层干部的极端不负责任。问责要讲实事求是，不能“一有错就问责，一问责就动纪”。要看是否造成危害后果，是否达到追责程度，危害结果是干部不作为慢作为乱作为造成的，还是客观原因造成的？再根据履职行为与责任后果之间的因果联系，按照“权责一致、错责相当”的原则界定责任，确定问责对象和问责方式，确保问责精准有效。.76%，同比增长7.25%。主要原因是由于各地各单位受理信访举报的时间不同，信访人担心信访件未被受理或重视不够，在等待的过程中重复反映问题，导致重复访数量居高不下。2019年越级访15件次，同比下降57.14%。主要原因是枣阳市纪委监委领导班子认真执行定期下访接访制度，主要领导每周四固定接访，去年共接待群众面访36批次581人次，上访对象无一人越级访，有效缓解了全市大信访压力，越级访乱象得到了遏止；二是自办案件增加，上级转交件下降。2019年共受理信访举报995件，同比基本持平。其中本级自收573件，占57.59%，同比增长57.85%；上级转交办422件，占42.41%，同比下降33.02%。主要原因是随着全面从严治党不断向纵深推进，信访干部履职尽责意识不断增强，办信办访能力增强，加之信访渠道的通畅及日益拓宽，干部主动接访、带案下访、重点约访的机制发挥了积极作用，群众在本级信访诉求能够得到有效解决，越级向上反映问题大幅减少。三是信访反映村级干部增加，乡科级干部减少。2019年信访反映村（社区）人员419件，同比增长16.06%，反映乡科级干部198件，同比下降30.5%。从中不难看出在全面从严治党的高压态势下，不敢腐的震慑已经形成，不能腐的笼子正在扎牢，不想腐的自觉逐步增强，但从村干部信访举报持续增长的趋势显示，全面从严治党“最后一米”的问题还不够彻底，违反群众纪律和廉洁纪律类问题仍然居高不下，破坏了党群干群关系，蚕食了群众切身利益。 闵翼飞）</h3>
        <h3>
          <b>三看处分条规。</b>
        </h3>
        <h3>违纪是指行为人实施了党纪处分条规所禁止的行为，对党、国家和人民利益具有一定的危害性，依照党纪处分条规应当受到党纪处分处罚的行为。任何违纪都必须同时具备“一定的危害性”、“违纪性”和“应受处罚性”这三个基本特征，不具有危害性或危害性没有达到违反党纪处分条规和应当受到党纪处分处罚的程度，就不是违纪。在实践中，对某一危害行为是否达到了一定程度，人们的认识往往不一，这就需要通过制定党纪处分条规加以规定，并明令禁止。《中国共产党纪律处分条例》规定的违纪行为有违反政治纪律、组织纪律、廉洁纪律、群众纪律、工作纪律、生活纪律行为；规定的情节有“情节较轻”、“情节较重”、“情节严重”，“较大损失”、“重大损失”、“不良影响和严重后果”等。在实践中，我们就要通过看党纪处分条规的规定，判明危害行为是“明禁”还是“无禁”，是否达到应当受到处罚的程度，做到“实事求是、依规依纪依法严肃问责、规范问责、精准问责、慎重问责”，防止出现执纪不当、问责泛化简单化等情况。</h3>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      PicBannertest1: require("../../../../assets/image/bannertest1.jpg"),
      PicBannertest2: require("../../../../assets/image/bannertest2.jpg")
    };
  },
  methods: {
    GoreportInternet() {
      this.$router.push("/forum");
    },
    GoreportEvaluation() {
      this.$router.push({ name: "forumClassroom" });
    },
    GoreportOutside() {
      this.$router.push({ name: "forumOutside" });
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
/*副导航兰*/
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
/*问卷调查正文*/
.text {
  background-color: white;
  padding: 44px 60px 121px 60px;
  margin: 0 auto;
}
.text h1 {
  font-size: 28px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 56px;
  text-align: center;
}
.text h2 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 44px;
  text-align: center;
  padding-bottom: 14px;
  border-bottom: 1px solid #E8E8E8;
  margin-bottom: 15px;
   text-align: center;
  display: flex;
  justify-content: center;
}
.text h3 {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 32px;
  text-indent: 2em;
  margin-bottom: 30px;
}
/*静态页面样式 */
.PIC-BOX {
  display: flex;
  justify-content: center;
}
.text h3 b {
  display: block;
  margin-top: 20px;
}
img{
  margin: 20px 0px;
}
.mg-16{
  margin: 0px 16px;
}
</style>